var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import apiClient, { InkyApiError, InkyApiStatus } from './InkyAPI';
import { DashCustomOrderNoteRequest, OrderNoteLogLevel } from '../Models/Dashboard/DashOrder';
import { DashCustomUserNoteRequest, UserNoteLogLevel, } from '../Models/Dashboard/DashUser';
import { InkyPortProductInfo } from '../Models/Dashboard/InkyPortProductInfo';
import { DashboardSalesCampaign } from '../Models/Dashboard/Sales/DashboardSalesCampaign';
// import { SalePost, SalesResponseData } from '../Components/Sales/SalesModel';
var DashboardAPI = /** @class */ (function () {
    function DashboardAPI() {
    }
    /**
     * Get All products that match parameter criteria
     * @param cancelTokenSource
     * @param query
     * @param start
     * @param count
     * @param includeBundles
     * @param publishStatus
     * @param includeRemoved Only relevant if the publish status is null (all products).
     */
    DashboardAPI.prototype.getAllProducts = function (cancelTokenSource, query, start, count, includeBundles, publishStatus, includeRemoved, showOnlyOnSale, includeChapters, distributionType) {
        var params = [];
        if (query)
            params.push(["query", query]);
        if (start)
            params.push(["start", start]);
        if (count)
            params.push(["count", count]);
        if (includeBundles)
            params.push(["includeBundles", includeBundles]);
        if (publishStatus)
            params.push(["publishStatus", publishStatus]);
        if (includeRemoved)
            params.push(["includeRemoved", includeRemoved]);
        if (showOnlyOnSale)
            params.push(["showOnlyOnSale", showOnlyOnSale]);
        if (includeChapters)
            params.push(["includeChapters", showOnlyOnSale]);
        if (distributionType) {
            switch (distributionType) {
                case "Digital":
                    params.push(["distributionType", 0]);
                    break;
                case "Print":
                    params.push(["distributionType", 1]);
                    break;
                default: break;
            }
        }
        return apiClient.getResponse("/dashboard/product", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getAllProductsV2 = function (abortSignal, query, start, count, includeBundles, publishStatus, includeRemoved, showOnlyOnSale, includeChapters, distributionType) {
        var params = [];
        if (query)
            params.push(["query", query]);
        if (start)
            params.push(["start", start]);
        if (count)
            params.push(["count", count]);
        if (includeBundles)
            params.push(["includeBundles", includeBundles]);
        if (publishStatus)
            params.push(["publishStatus", publishStatus]);
        if (includeRemoved)
            params.push(["includeRemoved", includeRemoved]);
        if (showOnlyOnSale)
            params.push(["showOnlyOnSale", showOnlyOnSale]);
        if (includeChapters)
            params.push(["includeChapters", showOnlyOnSale]);
        if (distributionType) {
            switch (distributionType) {
                case "Digital":
                    params.push(["distributionType", 0]);
                    break;
                case "Print":
                    params.push(["distributionType", 1]);
                    break;
                default: break;
            }
        }
        return apiClient.getResponseV2("/dashboard/product", abortSignal, params);
    };
    DashboardAPI.prototype.getAllCarouselItems = function (cancelTokenSource) {
        return apiClient.get("/dashboard/carousel", cancelTokenSource);
    };
    DashboardAPI.prototype.getCarouselItem = function (cancelTokenSource, itemId) {
        return apiClient.get("/dashboard/carousel/" + itemId, cancelTokenSource);
    };
    DashboardAPI.prototype.addNewCarouselItem = function (cancelTokenSource, carousel) {
        return apiClient.post("/dashboard/carousel/new", carousel, cancelTokenSource);
    };
    DashboardAPI.prototype.alterCarouselItems = function (cancelTokenSource, carousels) {
        return apiClient.post("/dashboard/carousel/alter", carousels, cancelTokenSource);
    };
    DashboardAPI.prototype.reOrderCarouselItems = function (cancelTokenSource, carouselOrders) {
        return apiClient.post("/dashboard/carousel/reOrder", carouselOrders, cancelTokenSource);
    };
    DashboardAPI.prototype.removeCarouselItem = function (cancelTokenSource, id) {
        return apiClient.post("/dashboard/carousel/remove?id=" + id, null, cancelTokenSource);
    };
    DashboardAPI.prototype.publishCarouselItem = function (cancelTokenSource, id) {
        return apiClient.post("/dashboard/carousel/publish?id=" + id, null, cancelTokenSource);
    };
    DashboardAPI.prototype.unPublishCarouselItem = function (cancelTokenSource, id) {
        return apiClient.post("/dashboard/carousel/unpublish?id=" + id, null, cancelTokenSource);
    };
    DashboardAPI.prototype.addCustomOrderNote = function (cancelTokenSource, orderId, message) {
        // Create paypload
        var payload = new DashCustomOrderNoteRequest();
        payload.orderId = orderId;
        payload.logLevel = OrderNoteLogLevel.Info;
        payload.message = message;
        return apiClient.post("/dashboard/orders/addCustomNote", payload, cancelTokenSource);
    };
    DashboardAPI.prototype.addCustomUserNote = function (cancelTokenSource, userId, message) {
        // Create paypload
        var payload = new DashCustomUserNoteRequest();
        payload.userId = userId;
        payload.logLevel = UserNoteLogLevel.Info;
        payload.message = message;
        return apiClient.post("/dashboard/users/addCustomNote", payload, cancelTokenSource);
    };
    DashboardAPI.prototype.getSeries = function (cancelTokenSource, query, count, publishStatus) {
        if (query || count || publishStatus) {
            var params = [];
            if (query) {
                params = __spreadArray(__spreadArray([], __read(params), false), [["query", query]], false);
            }
            if (count) {
                params = __spreadArray(__spreadArray([], __read(params), false), [["count", "" + count]], false);
            }
            if (publishStatus) {
                params = __spreadArray(__spreadArray([], __read(params), false), [["publishStatus", publishStatus]], false);
            }
            return apiClient.get("/dashboard/series", cancelTokenSource, params);
        }
        else {
            return apiClient.get("/dashboard/series", cancelTokenSource);
        }
    };
    DashboardAPI.prototype.getBundles = function (cancelTokenSource, query, count) {
        if (query) {
            var params = [["query", query]];
            if (count) {
                params = __spreadArray(__spreadArray([], __read(params), false), [["count", "" + count]], false);
            }
            return apiClient.get("/dashboard/bundles", cancelTokenSource, params);
        }
        else {
            return apiClient.get("/dashboard/bundles", cancelTokenSource);
        }
    };
    DashboardAPI.prototype.getAllSalesCampaigns = function (fromIndex, count, search, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var path, temp, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = "/dashboard/sales/";
                        temp = [];
                        if (fromIndex) {
                            temp.push("fromIndex=" + fromIndex);
                        }
                        if (count) {
                            temp.push("count=" + count);
                        }
                        if (search) {
                            temp.push("search=" + search);
                        }
                        if (temp.length > 0) {
                            path = path + "?" + temp.join('&');
                        }
                        return [4 /*yield*/, apiClient.getV4(path, abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, result.response];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.getSalesCampaign = function (id, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.getV4("/dashboard/sales/getCampaignById/" + id, abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, result.response];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.downloadSalesCampaign = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, apiClient.getFile('/dashboard/sales/exportAsExcel/' + id, {}, null)];
            });
        });
    };
    DashboardAPI.prototype.getSalesCampaignProductsForSeries = function (id, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.getV4("/dashboard/sales/getSeriesInfo/" + id, abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, result.response];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.alterSalesCampaign = function (salesCampaign, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/sales/alter", salesCampaign.toApi(), abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, DashboardSalesCampaign.createFromApi(result.response)];
                        }
                        else {
                            console.error("Something went wrong saving");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.createSalesCampaign = function (salesCampaign, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/sales/create", salesCampaign.toApi(), abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, DashboardSalesCampaign.createFromApi(result.response)];
                        }
                        else {
                            console.error("Something went wrong saving");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.publishSalesCampaign = function (salesCampaignId, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/sales/publish/" + salesCampaignId, null, abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, DashboardSalesCampaign.createFromApi(result.response)];
                        }
                        else {
                            console.error("Something went wrong publishing");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.unpublishSalesCampaign = function (salesCampaignId, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/sales/unpublish/" + salesCampaignId, null, abortSignal)];
                    case 1:
                        result = _a.sent();
                        if (result.status.type === "Success") {
                            return [2 /*return*/, DashboardSalesCampaign.createFromApi(result.response)];
                        }
                        else {
                            console.error("Something went wrong publishing");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // createSalesCampaigns(data: SalePost): Promise<AxiosResponse<SalePost>> {
    //     return apiClient.post<SalePost>("/dashboard/sales/create", data);
    // }
    DashboardAPI.prototype.getAllWheelItems = function (cancelTokenSource) {
        return apiClient.get("/dashboard/home/entry", cancelTokenSource);
    };
    DashboardAPI.prototype.alterWheelItems = function (cancelTokenSource, homeListEntries) {
        return apiClient.post("/dashboard/home/entry/alter", homeListEntries, cancelTokenSource);
    };
    DashboardAPI.prototype.removeWheelItem = function (cancelTokenSource, id) {
        return apiClient.post("/dashboard/home/entry/remove?id=" + id, null, cancelTokenSource);
    };
    DashboardAPI.prototype.publishWheelItem = function (cancelTokenSource, id) {
        return apiClient.post("/dashboard/home/entry/publish?id=" + id, null, cancelTokenSource);
    };
    DashboardAPI.prototype.unPublishWheelItem = function (cancelTokenSource, id) {
        return apiClient.post("/dashboard/home/entry/unpublish?id=" + id, null, cancelTokenSource);
    };
    DashboardAPI.prototype.reOrderWheelItems = function (cancelTokenSource, wheelOrders) {
        return apiClient.post("/dashboard/home/entry/reOrder", wheelOrders, cancelTokenSource);
    };
    DashboardAPI.prototype.invalidateCache = function (cancelTokenSource) {
        return apiClient.post("/dashboard/cache/invalidateAll", {}, cancelTokenSource);
    };
    DashboardAPI.prototype.addNewWheelItem = function (cancelTokenSource, homeListEntry) {
        console.log("Adding new wheel item");
        console.log(homeListEntry);
        return apiClient.post("/dashboard/home/entry/new", homeListEntry, cancelTokenSource);
    };
    DashboardAPI.prototype.addHomePageConfiguration = function (cancelTokenSource, id) {
        console.log("test " + id);
        return apiClient.post("/dashboard/homepage/top?typeId=" + id, cancelTokenSource);
    };
    DashboardAPI.prototype.addHomePageMessage = function (cancelTokenSource, message) {
        return apiClient.post("/dashboard/homepage/messaging/set", message, cancelTokenSource);
    };
    DashboardAPI.prototype.getAllRestrictedTerritories = function (cancelTokenSource) {
        return apiClient.get("/dashboard/home/restrictedTerritories", cancelTokenSource);
    };
    DashboardAPI.prototype.getAllPriceTiers = function (cancelTokenSource) {
        return apiClient.get("/dashboard/home/pricing/tiers", cancelTokenSource);
    };
    DashboardAPI.prototype.getIpTagList = function (cancelTokenSource, query) {
        var params = [];
        if (query) {
            params.push(["query", query]);
        }
        return apiClient.get("/dashboard/ipTags", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getImsItems = function (cancelTokenSource, query) {
        var params = [];
        if (query) {
            params.push(["query", query]);
        }
        return apiClient.get("/dashboard/ims", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getInkyPortProducts = function (cancelTokenSource, query) {
        return __awaiter(this, void 0, void 0, function () {
            var params, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [];
                        if (query) {
                            params.push(["query", query]);
                        }
                        return [4 /*yield*/, apiClient.getResponse("/dashboard/ims", cancelTokenSource, params)];
                    case 1:
                        resp = _a.sent();
                        if (resp.status.type === 'Success') {
                            return [2 /*return*/, resp.response.map(function (x) { return InkyPortProductInfo.createFromApi(x); })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.getInkyPortProduct = function (cancelTokenSource, sku) {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.getResponse("/dashboard/ims/".concat(sku), cancelTokenSource)];
                    case 1:
                        resp = _a.sent();
                        if (resp.status.type === 'Success') {
                            return [2 /*return*/, InkyPortProductInfo.createFromApi(resp.response)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.getImsItemDetails = function (cancelTokenSource, inventoryId) {
        return apiClient.get("/dashboard/ims/" + inventoryId, cancelTokenSource);
    };
    DashboardAPI.prototype.getOrderSummaries = function (cancelTokenSource, orderState, filterFromDate, filterOrderSelectTagId, start, count, searchText) {
        if (orderState === void 0) { orderState = null; }
        if (filterFromDate === void 0) { filterFromDate = null; }
        if (filterOrderSelectTagId === void 0) { filterOrderSelectTagId = null; }
        if (start === void 0) { start = null; }
        if (count === void 0) { count = null; }
        if (searchText === void 0) { searchText = null; }
        var params = [];
        if (orderState !== null) {
            params.push(["filterStatus", orderState]);
        }
        if (filterFromDate !== null) {
            params.push(["filterFromDate", filterFromDate.toISOString()]);
        }
        if (filterOrderSelectTagId !== null) {
            params.push(["filterTagIds", filterOrderSelectTagId]);
        }
        if (start !== null) {
            params.push(["start", start]);
        }
        if (count !== null) {
            params.push(["count", count]);
        }
        if (searchText !== null) {
            params.push(["searchText", searchText]);
        }
        //console.log(`params for orderState: ${orderState}, filterFromDate: ${filterFromDate}`);
        //console.log(params);
        return apiClient.getResponse("/dashboard/orders", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getUsers = function (cancelTokenSource, query) {
        return apiClient.getResponse("/dashboard/users", cancelTokenSource, [["query", query]]);
    };
    DashboardAPI.prototype.getUsersV2 = function (abortSignal, query) {
        return apiClient.getResponseV2("/dashboard/users", abortSignal, [["query", query]]);
    };
    DashboardAPI.prototype.getUserDetails = function (cancelTokenSource, userId) {
        return apiClient.getResponse("dashboard/users/products", cancelTokenSource, [["userId", "" + userId]]);
    };
    DashboardAPI.prototype.getUserDetailsWithPurchaseData = function (cancelTokenSource, userId) {
        return apiClient.getResponse("dashboard/users/" + userId, cancelTokenSource, []);
    };
    /*
    Only updates user.Roles for now
     */
    DashboardAPI.prototype.setUserDetails = function (cancelTokenSource, dashBoardUser) {
        return apiClient.postV2("/dashboard/users/alter/" + dashBoardUser.userId, dashBoardUser, cancelTokenSource);
    };
    /**
     * Filters out new Product Ids and adds them as comped to the user
     * @param cancelTokenSource
     * @param dashUserDetails
     */
    DashboardAPI.prototype.addUserCompensatedProducts = function (cancelTokenSource, dashUserDetails) {
        return apiClient.postV2("/dashboard/users/products/compAdd", dashUserDetails, cancelTokenSource);
    };
    /**
     * removes a userPurchaseData entry by id, does not affect any other tables
     * @param cancelTokenSource
     * @param userPurchaseDataId
     */
    DashboardAPI.prototype.removeUserProduct = function (cancelTokenSource, userPurchaseDataId) {
        return apiClient.post("/dashboard/users/products/delete/" + userPurchaseDataId, null, cancelTokenSource);
    };
    /**
     * @deprecated SKU's are not used
     */
    DashboardAPI.prototype.addUserProducts = function (cancelTokenSource, userId, skus) {
        var payload = {
            userId: userId,
            productSkus: skus
        };
        return apiClient.post("/dashboard/users/products/add", payload, cancelTokenSource);
    };
    DashboardAPI.prototype.deleteUser = function (userId, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/users/delete/" + userId, null, abortSignal)];
                    case 1:
                        res = _a.sent();
                        if (res.status.type !== "Success") {
                            throw res.status.message;
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    DashboardAPI.prototype.ingestProduct = function (cancelTokenSource, productId, remotePath) {
        return apiClient.get("/dashboard/ingest/encode/".concat(productId), cancelTokenSource, [
            ["forceReEncode", "true"],
            ["masterRecord", remotePath]
        ]);
    };
    DashboardAPI.prototype.getAnalyticsOrderData = function (cancelTokenSource, startDate, endDate) {
        console.log(startDate);
        console.log(endDate);
        var params = [];
        if (startDate)
            params.push(["start", startDate.toISOString()]);
        if (endDate)
            params.push(["end", endDate.toISOString()]);
        return apiClient.get("/analytics/getOrderData", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getAnalyticsOrderDataLegacy = function (cancelTokenSource) {
        return apiClient.get("/analytics/getOrderData", cancelTokenSource);
    };
    DashboardAPI.prototype.getAnalyticsUserData = function (cancelTokenSource, startDate, endDate) {
        var params = [];
        if (startDate)
            params.push(["start", startDate.toISOString()]);
        if (endDate)
            params.push(["end", endDate.toISOString()]);
        return apiClient.get("/analytics/getUserData", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getAnalyticsCartData = function (cancelTokenSource) {
        return apiClient.get("/analytics/getCartData", cancelTokenSource);
    };
    DashboardAPI.prototype.getAnalyticsPageMetrics = function (cancelTokenSource, startDate, endDate) {
        var params = [];
        if (startDate)
            params.push(["start", startDate.toISOString()]);
        if (endDate)
            params.push(["end", endDate.toISOString()]);
        return apiClient.get("/analytics/getPageMetrics", cancelTokenSource, params);
    };
    DashboardAPI.prototype.getSearchItemsToRemove = function (cancelTokenSource) {
        return apiClient.getResponse('/search/getOrphans', cancelTokenSource);
    };
    DashboardAPI.prototype.getSearchItemsToAdd = function (cancelTokenSource) {
        return apiClient.getResponse('/search/getActiveNotUploaded', cancelTokenSource);
    };
    DashboardAPI.prototype.removeInactiveSearchItems = function (cancelTokenSource) {
        return apiClient.post('/search/removeInactiveFromSearch', null, cancelTokenSource);
    };
    DashboardAPI.prototype.addMissingActiveSearchItems = function (cancelTokenSource) {
        return apiClient.post('/search/uploadAllToSearch', null, cancelTokenSource);
    };
    DashboardAPI.prototype.getShipmentProviderAccountInfo = function (cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = null;
                        return [4 /*yield*/, apiClient.getResponse('/dashboard/orders/shipping/getAccountInfo', cancelTokenSource)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    DashboardAPI.prototype.GetSalesReport = function (reportRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.getFile('/reports/asExcelFile', reportRequest, null)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /* REPORTING */
    DashboardAPI.prototype.getAverageOrderValue = function (cancelTokenSource, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = [];
                if (startDate)
                    params.push(["start", startDate.toISOString()]);
                if (endDate)
                    params.push(["end", endDate.toISOString()]);
                return [2 /*return*/, apiClient.getResponse('/analytics/averageOrderValue', cancelTokenSource, params)];
            });
        });
    };
    DashboardAPI.prototype.getAverageOrderProductQuantity = function (cancelTokenSource, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = [];
                if (startDate)
                    params.push(["start", startDate.toISOString()]);
                if (endDate)
                    params.push(["end", endDate.toISOString()]);
                return [2 /*return*/, apiClient.getResponse('/analytics/averageOrderProductQuantity', cancelTokenSource, params)];
            });
        });
    };
    DashboardAPI.prototype.getUniqueLoggedInCustomers = function (cancelTokenSource, startDate, endDate) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = [];
                if (startDate)
                    params.push(["start", startDate.toISOString()]);
                if (endDate)
                    params.push(["end", endDate.toISOString()]);
                return [2 /*return*/, apiClient.getResponse('analytics/uniqueLoggedInCustomers', cancelTokenSource, params)];
            });
        });
    };
    DashboardAPI.prototype.getTopSellingProducts = function (cancelTokenSource, startDate, endDate, maxItems) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = [];
                if (startDate)
                    params.push(["start", startDate.toISOString()]);
                if (endDate)
                    params.push(["end", endDate.toISOString()]);
                if (maxItems)
                    params.push("maxItems", maxItems);
                return [2 /*return*/, apiClient.getResponse('analytics/topSellingProducts', cancelTokenSource, params)];
            });
        });
    };
    DashboardAPI.prototype.setRoles = function (cancelTokenSource, userId, role) {
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                payload = {
                    Auth0Id: userId,
                    NewRoles: role
                };
                return [2 /*return*/, apiClient.post("/dashboard/users/SetRoles", payload, cancelTokenSource)];
            });
        });
    };
    DashboardAPI.prototype.ValidateDashboardSalesImport = function (form, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/sales/ValidateFromCsv", form, abortSignal)];
                    case 1:
                        response = _a.sent();
                        if (response.status.type === "Success") {
                            return [2 /*return*/, response.response];
                        }
                        else {
                            throw new InkyApiError(response.status.message, InkyApiStatus.Default);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DashboardAPI.prototype.ValidateAndImportDashboardSalesImport = function (form, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.postV4("/dashboard/sales/CreateFromCsv", form, abortSignal)];
                    case 1:
                        response = _a.sent();
                        if (response.status.type === "Success") {
                            return [2 /*return*/, response.response];
                        }
                        else {
                            throw new InkyApiError("Something Failed with ValidateTrilogyExport endpoint", InkyApiStatus.Default);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DashboardAPI;
}());
var dashboard = new DashboardAPI();
export default dashboard;
